import { useCustomReducer } from '../../../../../base/customHooks'
import IPButton from '../../../../../components/IPButton'
import { useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { exportToXLSXVDF, formatCurrencyTemlik, formatDate } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetVodafoneTemlikRequest, GetVodafoneTemlikResponse } from '../models/model'
import { GetTemlikDetailListApi } from '../services/getTemlikDetailList'
import moment from 'moment'

interface IVodafoneTemlikDetailState {
  imei?: string
  shopCode?: string
  belgeNoStart?: string
  belgeNoEnd?: string
  bayiKodu?: string
  periodStart?: string
  periodEnd?: string
  belgeTuruOptions: ISelectOption[]
  selectedBelgeTuru?: ISelectOption[]
}

const defaultBelgeTuruOptions: ISelectOption[] = [
  { value: 'A1', label: 'Bayi Risk Virmanı (A1)' },
  { value: 'A2', label: 'Bayi Risk VRM - Fark (A2)' },
  { value: 'A9', label: 'Bayi Risk VRM - Temlik (A9)' },
  { value: 'A0', label: 'Bayi Virmanı Ters İşlem (A0)' },
  { value: 'A4', label: 'Bayi Temlik Virmanı (A4)' },
  { value: 'A3', label: 'PGD - Datagate Fatura (A3)' },
  { value: 'B3', label: 'SFT - VDF Fatura (B3)' },
  { value: 'A6', label: 'PGD - DGT Payı (A6)' },
]

const ALL_BELGE_TURU_VALUE = '__ALL_BELGE_TURU__'

const getBelgeTuruLabel = (belgeTuru: string) => {
  const option = defaultBelgeTuruOptions.find(item => item.value.toString() === belgeTuru?.toString())
  return option?.label ?? belgeTuru
}

const mergeBelgeTuruOptions = (currentOptions: ISelectOption[], selectedOptions?: ISelectOption[]): ISelectOption[] => {
  const allOptions = [...currentOptions]

    ; (selectedOptions ?? []).forEach(option => {
      if (!allOptions.find(item => item.value.toString() === option.value.toString())) {
        allOptions.push(option)
      }
    })

  return allOptions
}

function VodafoneTemlikDetail(props: BaseComponentWithContextProps) {
  const getInitialState = (): IVodafoneTemlikDetailState => {
    return {
      belgeTuruOptions: defaultBelgeTuruOptions,
      selectedBelgeTuru: defaultBelgeTuruOptions,
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IVodafoneTemlikDetailState>(intialState)
  const [temlikData, setTemlikData] = useState<GetVodafoneTemlikResponse[]>([])

  const [startDate, setStartDate] = useState<string | undefined>(undefined)
  const [endDate, setEndDate] = useState<string | undefined>(undefined)
  const [aktivasyonStartDate, setAktivasyonStartDate] = useState<string | undefined>(undefined)
  const [aktivasyonEndDate, setAktivasyonEndDate] = useState<string | undefined>(undefined)
  const [currentPage, setCurrentPage] = useState(0)

  const belgeTuruSelectOptions = useMemo<ISelectOption[]>(
    () => [
      {
        value: ALL_BELGE_TURU_VALUE,
        label: <span style={{ color: '#007bff', fontWeight: 600 }}>Tümünü Seç</span>,
      },
      ...state.belgeTuruOptions,
    ],
    [state.belgeTuruOptions]
  )

  const hasRangeMismatch = (start?: string, end?: string) => {
    return (!!start && !end) || (!start && !!end)
  }

  const onBelgeTuruChange = (options: ISelectOption[]) => {
    if (!options || options.length === 0) {
      setState({ selectedBelgeTuru: [] })
      return
    }

    const normalizedOptions = options.filter(item => item.value.toString() !== ALL_BELGE_TURU_VALUE)
    const mergedOptions = mergeBelgeTuruOptions(state.belgeTuruOptions, normalizedOptions)

    setState({ belgeTuruOptions: mergedOptions })

    const hasAllSelected = options.some(item => item.value.toString() === ALL_BELGE_TURU_VALUE)
    if (hasAllSelected) {
      setState({ selectedBelgeTuru: mergedOptions })
      return
    }

    setState({ selectedBelgeTuru: normalizedOptions })
  }

  const getTemlikDetailList = async () => {
    if (!state.selectedBelgeTuru || state.selectedBelgeTuru.length === 0) {
      return Swal.fire({
        icon: 'error',
        title: 'Belge Türü seçimi zorunludur.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }


    const req: GetVodafoneTemlikRequest = {
      Imei: state.imei?.trim() ?? '',
      ShopCode: state.shopCode?.trim() ?? '',
      BelgeTuru: state.selectedBelgeTuru.map(item => item.value.toString()),
      BelgeNoStart: state.belgeNoStart?.trim() ?? '',
      BelgeNoEnd: state.belgeNoEnd?.trim() ?? '',
      StartDate: startDate ? formatDate(startDate as any) : '',
      EndDate: endDate ? formatDate(endDate as any) : '',
      AktivasyonStartDate: aktivasyonStartDate ? formatDate(aktivasyonStartDate as any) : '',
      AktivasyonEndDate: aktivasyonEndDate ? formatDate(aktivasyonEndDate as any) : '',
      BayiKodu: state.bayiKodu?.trim() ?? '',
      PeriodStart: state.periodStart?.trim() ?? '',
      PeriodEnd: state.periodEnd?.trim() ?? '',
    }

    props.showLoading()
    const api: GetTemlikDetailListApi = new GetTemlikDetailListApi({})

    api
      .getDetailList(req)
      .then(result => {
        if (result) {
          setTemlikData(result)
          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Temlik detay verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
        } else {
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        props.hideLoading()
        Swal.fire({
          icon: 'error',
          title: err?.description ?? 'Temlik detay verisi alınırken hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      })
  }

  const columnDefinitions = [
    { Header: 'IMEI', accessor: 'imei' },
    { Header: 'Aktivasyon Tarihi', accessor: 'aktivasyonTarihi' },
    { Header: 'VDF Bayi Kodu', accessor: 'vdfBayiKodu' },
    { Header: 'Alt Bayi Kod Aralığı', accessor: 'altBayiKodAralik' },
    { Header: 'Marka', accessor: 'marka' },
    { Header: 'Model', accessor: 'model' },
    { Header: 'EAN Kodu', accessor: 'eanKodu' },
    { Header: 'Ürün Kodu', accessor: 'urunKodu' },
    { Header: 'VDF Ürün Kodu', accessor: 'vdfUrunKodu' },
    { Header: 'Ürün Açıklaması', accessor: 'urunAciklamasi' },
    { Header: 'Belge Türü', accessor: 'belgeTuru' },
    { Header: 'Açıklama', accessor: 'aciklama' },
    { Header: 'Belge No', accessor: 'belgeNo' },
    { Header: 'Yıl', accessor: 'yil' },
    { Header: 'Kayıt Tarihi', accessor: 'kayitTarih' },
    { Header: 'Dönem', accessor: 'donem' },
    { Header: 'Tutar', accessor: 'tutar' },
  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableDataAndTotal = useMemo(() => {
    const tableData = temlikData.map(item => {
      if (item.BELGE_TURU == "A0" || item.BELGE_TURU == "A2") {
        item.TUTAR = -(item.TUTAR)
      }
      return {
        imei: item.IMEI,
        aktivasyonTarihi: item.AKTIVASYON_TARIHI ? moment(item.AKTIVASYON_TARIHI).format('DD.MM.YYYY') : '',
        vdfBayiKodu: item.VDF_BAYI_KODU,
        altBayiKodAralik: item.ALT_BAYI_KOD_ARALIK,
        marka: item.MARKA,
        model: item.MODEL,
        eanKodu: item.EAN_KODU,
        urunKodu: item.URUN_KODU,
        vdfUrunKodu: item.VDF_URUN_KODU,
        urunAciklamasi: item.URUN_ACIKLAMASI,
        bayiKodu: item.BAYI_KODU,
        belgeTuru: (item.BELGE_TURU),
        aciklama: item.ACIKLAMA,
        belgeNo: item.BELGE_NO,
        yil: item.YIL,
        sirket: item.SIRKET,
        kayitTarih: item.KAYIT_TARIH ? moment(item.KAYIT_TARIH).format('DD.MM.YYYY') : '',
        donem: item.DONEM,
        tutar: <div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(item.TUTAR)}</div>,
      }
    })

    return {
      tableData,
    }
  }, [temlikData])

  const excelButton = async () => {
    try {
      if (!temlikData || temlikData.length === 0) {
        return Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
      }

      const data: any[] = temlikData.map(item => ({
        IMEI: item.IMEI,
        'AKTİVASYON TARİHİ': item.AKTIVASYON_TARIHI ? moment(item.AKTIVASYON_TARIHI).format('DD.MM.YYYY') : '',
        'VDF BAYİ KODU': item.VDF_BAYI_KODU,
        'ALT BAYİ KOD ARALIK': item.ALT_BAYI_KOD_ARALIK,
        MARKA: item.MARKA,
        MODEL: item.MODEL,
        'EAN KODU': item.EAN_KODU,
        'ÜRÜN KODU': item.URUN_KODU,
        'VDF ÜRÜN KODU': item.VDF_URUN_KODU,
        'ÜRÜN AÇIKLAMASI': item.URUN_ACIKLAMASI,
        'BAYİ KODU': item.BAYI_KODU,
        'BELGE TÜRÜ': (item.BELGE_TURU),
        AÇIKLAMA: item.ACIKLAMA,
        'BELGE NO': item.BELGE_NO,
        YIL: item.YIL,
        'KAYIT TARİH': item.KAYIT_TARIH ? moment(item.KAYIT_TARIH).format('DD.MM.YYYY') : '',
        DÖNEM: item.DONEM,
        TUTAR: (item.BELGE_TURU == "A0" || item.BELGE_TURU == "A2") ? formatCurrencyTemlik(item.TUTAR) : formatCurrencyTemlik(item.TUTAR),
      }))

      exportToXLSXVDF(data, 'Temlik Detay', 'R')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description ?? 'Excel aktarımında hata oluştu.',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Temlik Detay</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>

      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='Imei'
              name='Imei'
              label='IMEI'
              value={state.imei}
              onChange={e => setState({ imei: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='ShopCode'
              name='ShopCode'
              label='Mağaza Kodu'
              value={state.shopCode}
              onChange={e => setState({ shopCode: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-4'>
            <IPSelectBox
              isMulti
              isClearable
              isCreatableSelect
              id='BelgeTuru'
              name='BelgeTuru'
              placeholder='Belge Türü Seçiniz...'
              isSearchable
              onChangeMulti={(options: ISelectOption[]) => {
                onBelgeTuruChange(options)
              }}
              onCreateOption={(options: ISelectOption[]) => {
                const normalizedOptions = options.filter(item => item.value.toString() !== ALL_BELGE_TURU_VALUE)
                const mergedOptions = mergeBelgeTuruOptions(state.belgeTuruOptions, normalizedOptions)
                setState({
                  belgeTuruOptions: mergedOptions,
                  selectedBelgeTuru: normalizedOptions,
                })
              }}
              options={belgeTuruSelectOptions}
              value={state.selectedBelgeTuru}
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='BelgeNoStart'
              name='BelgeNoStart'
              label='Belge No Başlangıç'
              value={state.belgeNoStart}
              onChange={e => setState({ belgeNoStart: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='BelgeNoEnd'
              name='BelgeNoEnd'
              label='Belge No Bitiş'
              value={state.belgeNoEnd}
              onChange={e => setState({ belgeNoEnd: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='PeriodStart'
              name='PeriodStart'
              label='Dönem Başlangıç'
              value={state.periodStart}
              onChange={e => setState({ periodStart: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='PeriodEnd'
              name='PeriodEnd'
              label='Dönem Bitiş'
              value={state.periodEnd}
              onChange={e => setState({ periodEnd: e.target.value })}
              isActive
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label='Kayıt Başlangıç Tarihi'
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label='Kayıt Bitiş Tarihi'
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='AktivasyonStartDate'
              name='AktivasyonStartDate'
              label='Aktivasyon Başlangıç'
              value={aktivasyonStartDate}
              onChange={e => setAktivasyonStartDate(e.target.value)}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='AktivasyonEndDate'
              name='AktivasyonEndDate'
              label='Aktivasyon Bitiş'
              value={aktivasyonEndDate}
              onChange={e => setAktivasyonEndDate(e.target.value)}
              isActive
            />
          </div>
        </div>

        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getTemlikDetailList()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>

        <label style={{ color: 'red' }}>
          <b>Dönem</b> alanlarını <b>YYYYMM</b> formatında giriniz. Örnek: {moment(new Date()).format('YYYYMM')}
        </label>
      </form>

      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableDataAndTotal.tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={13}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}

export default componentWithContext(VodafoneTemlikDetail)
